import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Persona } from 'src/app/_models/persona';

@Component({
  selector: 'app-persona-card',
  standalone: false,
  templateUrl: './persona-card.component.html',
  styleUrls: ['./persona-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonaCardComponent implements OnInit {

  @Input()
  persona: Persona;

  constructor() { }

  ngOnInit() {
  }

}
